import * as USER_TYPE from 'constant/user-types'
import React, { useEffect } from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import NameInput from 'view/component/form-items/name-input'
import ColorInput from 'view/component/form-items/color-input'
import { connect } from 'react-redux'
import IntroductionInput from 'view/component/form-items/introduction-input'
import ShowToggle from 'view/component/form-items/show-toggle'
import URLInput from 'view/component/form-items/url-input'
import Upload from 'view/component/form-items/upload'
import WebpageCheckbox from 'view/component/form-items/site-webpage-checkbox'

const SiteForm = ({ site, siteUuid, form, user }) => {
  useEffect(() => {
    form.setFieldsValue(site)
  }, [site])
  const disabled = user.user_type.name !== USER_TYPE.ADMIN
  return (
    <Form
      form={form}
      layout='vertical'
    >
      {addFields(site, disabled)}
    </Form>
  )
}

/* eslint-disable max-lines-per-function */
const addFields = (site, disabled) => (
  <>
    <NameInput
      name='site_name'
      title='Site Name'

    />
    <IntroductionInput
      name='short_description'
      title='Description'

    />
    <URLInput
      name='site_landing_page_url'
      title='Site Landing Page URL'
    />
    <WebpageCheckbox />
    <Upload
      fileName={site?.site_logo && site.site_logo}
      name='site_logo'
      required
      title='Site Logo'
    />
    <Upload
      fileName={site?.site_favicon && site.site_favicon}
      name='site_favicon'
      required
      title='Site Favicon'
    />
    <ColorInput />
    <ShowToggle show={site && site.show} />
    <NameInput
      disabled={disabled}
      name='cp_admin_ad_group_uuid'
      title='CP Admin AD Group UUID'
    />
    <NameInput
      disabled={disabled}
      name='cp_super_ad_group_uuid'
      title='CP Super AD Group UUID'
    />
    <NameInput
      disabled={disabled}
      name='cp_general_ad_group_uuid'
      title='CP General AD Group UUID'
    />
    {/*    <NameInput
      disabled={disabled}
      name='pl_admin_ad_group_uuid'
      title='PL Admin AD Group UUID'
    />
    <NameInput
      disabled={disabled}
      name='pl_super_ad_group_uuid'
      title='PL Super AD Group UUID'
    />
    <NameInput
      disabled={disabled}
      name='pl_general_ad_group_uuid'
      title='PL General AD Group UUID'
    />
    <NameInput
      disabled={disabled}
      name='pl_default_uuid'
      title='PL Default UUID'
    /> */}
    <NameInput
      disabled={disabled}
      name='cp_default_uuid'
      title='CP Default UUID'
    />
  </>
)

SiteForm.propTypes = {
  form: PropTypes.object,
  site: PropTypes.object,
  siteUuid: PropTypes.string,
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user
  }
}
export default connect(mapStateToProps)(SiteForm)
